export default "__VITE_ASSET__d20c0a90__"